module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    staticClass: "pa-4",
    attrs: {
      "align-center": "align-center",
      "justify-center": "justify-center"
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center"
  }, [_c('v-form', {
    attrs: {
      "disabled": _vm.isLoading
    }
  }, [_c('small', {
    staticClass: "font-size-11"
  }, [_vm._v("¿Cuenta con un contrato vigente?")]), _c('v-slide-group', {
    attrs: {
      "mandatory": "mandatory",
      "show-arrows": ""
    },
    model: {
      value: (_vm.tipoUsuario),
      callback: function($$v) {
        _vm.tipoUsuario = $$v
      },
      expression: "tipoUsuario"
    }
  }, _vm._l((_vm.tiposUsuario), function(n, index) {
    return _c('v-slide-item', {
      key: index,
      staticClass: "animated fadeInLeft faster",
      attrs: {
        "value": n.value
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(ref) {
          var active = ref.active;
          var toggle = ref.toggle;

          return [_c('v-card', {
            staticClass: "elevation-1 ma-1 d-flex ai-center jc-center text-center flex-1",
            attrs: {
              "color": active ? 'primary' : 'secondary primary--text',
              "height": "60",
              "dark": active,
              "width": "140"
            },
            on: {
              "click": toggle
            }
          }, [_c('span', {
            staticClass: "font-size-13 font-weight-700"
          }, [_vm._v(_vm._s(n.name))])])]
        }
      }], null, true)
    })
  }), 1), (_vm.tipoUsuario === 'usuario-contrato') ? _c('div', {
    staticClass: "d-flex items-end jc-end"
  }, [_c('v-text-field', {
    ref: "ruc",
    attrs: {
      "light": "light",
      "prepend-icon": "circle",
      "label": "RUC (Requerido)",
      "type": "number",
      "hide-details": "hide-details"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetchGetDatosSunat()
      }
    },
    model: {
      value: (_vm.ruc),
      callback: function($$v) {
        _vm.ruc = $$v
      },
      expression: "ruc"
    }
  }), _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "ml-4",
          attrs: {
            "fab": "fab",
            "disabled": _vm.isLoading,
            "small": "small"
          },
          on: {
            "click": function($event) {
              return _vm.fetchGetDatosSunat()
            }
          }
        }, 'v-btn', attrs, false), on), [_c('img', {
          attrs: {
            "src": require("../assets/sunat.svg"),
            "width": "25",
            "height": "25"
          }
        })])]
      }
    }], null, false, 3936401355)
  }, [_c('small', [_vm._v("Obtener datos de SUNAT")])])], 1) : _vm._e(), _c('v-text-field', {
    ref: "nombre",
    attrs: {
      "light": "light",
      "prepend-icon": "person",
      "label": "Nombre personal o Razón social",
      "type": "text",
      "hint": _vm.direccion,
      "persistent-hint": _vm.direccion !== '',
      "hide-details": !_vm.direccion
    },
    on: {
      "keyup": [_vm.uppercase, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetchRegistrarme()
      }]
    },
    model: {
      value: (_vm.nombre),
      callback: function($$v) {
        _vm.nombre = $$v
      },
      expression: "nombre"
    }
  }), _c('v-text-field', {
    ref: "username",
    attrs: {
      "light": "light",
      "prepend-icon": "email",
      "label": "Email (Requerido)",
      "type": "email",
      "hide-details": "hide-details"
    },
    on: {
      "keyup": [_vm.lowercase, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetchRegistrarme()
      }]
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  }), _c('v-text-field', {
    ref: "password",
    attrs: {
      "prepend-icon": "lock",
      "append-icon": _vm.showPassword ? 'visibility' : 'visibility_off',
      "type": _vm.showPassword ? 'text' : 'password',
      "label": "Ingrese una contraseña",
      "hint": "La contraseña ingresada será encriptada para mayor seguridad",
      "persistent-hint": "persistent-hint"
    },
    on: {
      "click:append": function($event) {
        _vm.showPassword = !_vm.showPassword
      },
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetchRegistrarme()
      }
    },
    scopedSlots: _vm._u([{
      key: "progress",
      fn: function() {
        return [_c('v-progress-linear', {
          attrs: {
            "value": _vm.progress,
            "color": _vm.color,
            "absolute": "",
            "height": "2"
          }
        })]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _c('v-checkbox', {
    staticClass: "mt-0 pt-2",
    attrs: {
      "color": "info"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('strong', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
            }
          }
        }, [_vm._v("Acepto compartir datos -  "), _c('a', {
          attrs: {
            "href": "#"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.redirectProteccion()
            }
          }
        }, [_vm._v("LEY Nº 29733")])])]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.aceptaPoliticasDePrivacidad),
      callback: function($$v) {
        _vm.aceptaPoliticasDePrivacidad = $$v
      },
      expression: "aceptaPoliticasDePrivacidad"
    }
  }), _c('v-btn', {
    attrs: {
      "block": "block",
      "color": "primary",
      "loading": _vm.isLoading
    },
    on: {
      "click": function($event) {
        return _vm.fetchRegistrarme()
      }
    }
  }, [_c('small', [_vm._v(" Registrarme")])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b0895652","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Register_user.vue
// module id = 525
// module chunks = 1